import { initializeApp } from 'firebase/app';
import { ReCaptchaEnterpriseProvider, initializeAppCheck } from 'firebase/app-check';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
let client;
export function initializeFirebaseClient(config) {
    if (client)
        return client;
    const app = initializeApp(config);
    const auth = getAuth(app);
    const firestore = getFirestore(app);
    const functions = getFunctions(app, 'us-central1');
    const storage = getStorage(app);
    if (config.useEmulators) {
        connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
        connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
        connectFunctionsEmulator(functions, '127.0.0.1', 5001);
        connectStorageEmulator(storage, '127.0.0.1', 9199);
    }
    const appCheck = typeof window !== 'undefined' && config.appCheckSiteKey
        ? initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(config.appCheckSiteKey),
            isTokenAutoRefreshEnabled: true,
        })
        : undefined;
    client = appCheck
        ? { app, auth, firestore, functions, storage, appCheck }
        : { app, auth, firestore, functions, storage };
    return client;
}
